<template>
  <div>
    <Head title="關於我們" />
    <ScrollTop />

    <div class="w-full mt-5">
      <figure class="mt-8 mb-16">
        <img src="/images/aboutMe01.jpg" />
      </figure>
      <figure>
        <img src="/images/aboutMe02.jpg" />
      </figure>
      <div class="flex h-24">
        <div
          style="color: #477686"
          class="text-6xl font-bold md:w-52 mt-auto break-normal"
        >
          初衷
        </div>
        <div
          class="md:w-full h-0.5 inline-block mt-20 mx-5 flex-grow"
          style="background-color: #477686"
        ></div>
        <img
          class="md:w-1/5 md:h-2/5 mt-16"
          src="/images/aboutMe03.jpg"
          alt=""
        />
      </div>
      <div style="background-color: #c8d5d9" class="w-full mt-4 mb-6 p-2">
        <p>
          吃貨家是由一群貪吃鬼組成的家庭，有愛吃海鮮的、有無肉不歡的<br />
          或是常宅在家喜愛各式方便快速上桌的、更有熱衷自己下廚烹飪的，<br />
          聚在一起討論並尋找各式各樣的美食。
        </p>
      </div>
      <hr style="border-color: #477686" class="border" />
      <figure class="mt-16">
        <img src="/images/aboutMe04.jpg" />
      </figure>
      <div class="flex h-24">
        <div
          style="color: #477686"
          class="text-6xl font-bold md:w-52 mt-auto break-normal"
        >
          堅持
        </div>
        <div
          class="md:w-full h-0.5 inline-block mt-20 mx-5 flex-grow"
          style="background-color: #477686"
        ></div>
        <img
          class="md:w-1/5 md:h-2/5 mt-16"
          src="/images/aboutMe05.jpg"
          alt=""
        />
      </div>
      <div style="background-color: #c8d5d9" class="w-full mt-4 mb-6 p-2">
        <p>
          我們每樣商品都是秉持著自己敢吃、敢拿給家人吃，精挑細選出來的，<br />
          從生鮮、蔬果、零食、各式調理到異國調味品，<br />
          提供數百項美味，以多品項少份量的方式，讓各位吃貨買的安心、吃的開心。
        </p>
      </div>
      <hr style="border-color: #477686" class="border" />
      <figure class="mt-16">
        <img src="/images/aboutMe06.jpg" />
      </figure>
      <figure class="mt-16">
        <img src="/images/aboutMe07.jpg" />
      </figure>
      <figure class="my-16">
        <img src="/images/aboutMe08.jpg" />
      </figure>
      <div class="flex h-24">
        <div
          style="color: #477686"
          class="text-6xl font-bold md:w-52 mt-auto break-normal"
        >
          品質
        </div>
        <div
          class="md:w-full h-0.5 inline-block mt-20 mx-5 flex-grow"
          style="background-color: #477686"
        ></div>
        <img
          class="md:w-1/5 md:h-2/5 mt-16"
          src="/images/aboutMe09.jpg"
          alt=""
        />
      </div>
      <div style="background-color: #c8d5d9" class="w-full mt-4 mb-6 p-2">
        <p>
          吃貨家在提供眾多選擇的同時，也保證以完善且衛生的倉儲環境，<br />
          搭配最適宜的運輸條件，將各式美味食品安全的交到各位吃貨手上，<br />
          歡迎大家一起加入吃貨家的大家庭。
        </p>
      </div>
    </div>
  </div>
</template>

<script>
import Layout from "@/Shared/Layout";
import ScrollTop from "primevue/scrolltop";

export default {
  components: { ScrollTop },
  layout: Layout,
  data() {
    return {
      activeIndex: 0,
    };
  },
  methods: {
    //
  },
  mounted() {
    //
  },
};
</script>

<style>
/* HTML5 display-role reset for older browsers */

figure {
  display: block;
}

body {
  line-height: 1;
}

ol,
ul {
  list-style: none;
}

li {
  line-height: 2;
}

* {
  font-family: "Noto Sans TC", sans-serif;
}

p {
  font-size: 1.5rem;
  line-height: 2;
}

table,
th,
td {
  border: 1px solid rgb(0, 0, 0);
  padding: 0.5rem;
  text-align: left;
  width: 24em;
}

* {
  font-family: "Noto Sans TC", sans-serif;
}

p {
  font-size: 1.25rem;
  line-height: 2;
}

h1 {
  font-size: 2.25rem;
  margin: 0.67rem 0;
  font-weight: 700;
}

h2 {
  font-size: 1.875rem;
  margin: 0.67rem 0;
  font-weight: 700;
}

h3 {
  font-size: 1.5rem;
  margin: 0.67rem 0;
  font-weight: 700;
}
</style>